import { QueryFilter, Response } from '../../../../../_metronic/helpers'

/** Estado do usuário logado para uma nota. `NENHUMA` não é persistido: só existe na resposta. */
export type SituacaoLeitura = 'NENHUMA' | 'LIDA' | 'ADIADA'

/** Rótulo do admin, derivado de `publicada` + `dtPublicacao` (não vem do backend). */
export type SituacaoPublicacao = 'RASCUNHO' | 'AGENDADA' | 'PUBLICADA'

/** Item da listagem admin (`GET /notas-versao`). */
export interface NotaVersaoList {
  id: number
  versao: string
  titulo: string
  dtPublicacao: string
  publicada: boolean
}

/** Detalhe admin (`GET /notas-versao/{id}`). O `conteudo` é HTML não sanitizado pelo servidor. */
export interface NotaVersaoView extends NotaVersaoList {
  conteudo: string
  createdAt?: string
  updatedAt?: string
}

/** Corpo de `POST`/`PUT /notas-versao`. `dtPublicacao` no formato `yyyy-MM-ddTHH:mm:ss`. */
export interface NotaVersaoDto {
  versao: string
  titulo: string
  conteudo: string
  dtPublicacao: string
  publicada: boolean
}

/** Resposta de `POST /notas-versao/imagens`: `url` é relativa à raiz da API. */
export interface ImagemNotaVersaoUpload {
  id: string
  url: string
}

/** Item do histórico do usuário (`GET /notas-versao/usuario`), sem conteúdo. */
export interface NotaVersaoUsuarioItem {
  id: number
  versao: string
  titulo: string
  dtPublicacao: string
  situacao: SituacaoLeitura
  dtLeitura?: string | null
  dtAdiamento?: string | null
}

/** Vigente e detalhe do usuário (`/notas-versao/usuario/vigente` e `/usuario/{id}`). */
export interface NotaVersaoUsuario extends NotaVersaoUsuarioItem {
  conteudo: string
}

export type NotasVersaoQueryResponse = Response<NotaVersaoList[]>
export type NotasVersaoHistoricoQueryResponse = Response<NotaVersaoUsuarioItem[]>

export const situacaoPublicacao = (
  nota: Pick<NotaVersaoList, 'publicada' | 'dtPublicacao'>,
  agora: Date
): SituacaoPublicacao => {
  if (!nota.publicada) return 'RASCUNHO'
  return new Date(nota.dtPublicacao).getTime() > agora.getTime() ? 'AGENDADA' : 'PUBLICADA'
}

/** `datetime-local` entrega `yyyy-MM-ddTHH:mm`; o backend espera os segundos. */
export const paraDataHoraBackend = (valor: string): string =>
  valor.length === 16 ? `${valor}:00` : valor

/** O inverso: o backend devolve `yyyy-MM-ddTHH:mm:ss(.SSS)` e o `datetime-local` aceita até os minutos. */
export const paraDataHoraInput = (valor?: string | null): string =>
  valor ? valor.slice(0, 16) : ''

/**
 * Filtros da listagem admin no contrato da N1: `search` é texto livre (título ou versão) e
 * `publicada` vai como parâmetro próprio, omitido quando o filtro é "todas".
 */
export const filtrosListagemAdmin = (
  texto: string,
  publicada?: boolean
): { search: string; filters: QueryFilter[] } => ({
  search: texto.trim(),
  filters: publicada === undefined ? [] : [{ field: 'publicada', operator: '=', value: publicada }],
})
